// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__jBXoz","notes":"Notes_notes__3DRYD","note":"Notes_note__3QREA","markdown":"Notes_markdown__1SaD3"};